<template>
  <v-container grid-list-md>
    <v-flex>
      <v-card>
        <v-card-title>
          <h1>Admins' Actions List</h1>
          <v-spacer/>
        </v-card-title>
        <v-card-text>
          <v-layout>
            <v-flex xs4>
              <v-text-field
                append-icon="search"
                label="Search by Username"
                v-model="search.filterByName"
              ></v-text-field>
            </v-flex>
            <v-flex xs4>
              <v-text-field
                append-icon="search"
                label="Search by Email"
                v-model="search.filterByEmail"
              ></v-text-field>
            </v-flex>
            <v-flex xs4>
              <v-select
                autocomplete
                :items="getUserActionTypes"
                v-model="search.filterType"
                label="Types"/>
            </v-flex>
          </v-layout>

          <v-data-table
            :headers="headers"
            :items="getUsersActions"
            :pagination.sync="pagination"
            :total-items="totalItemsInTable"
            class="elevation-1"
          >
            <!--:search="search"-->
            <template slot="items" slot-scope="props">
              <td>{{ props.item.user.userName }}</td>
              <td>{{ props.item.user.email }}</td>
              <td>{{ getDate(props.item.actionDate) }}</td>
              <td>{{ props.item.action }}</td>
              <td>
                <v-tooltip bottom>
                  <v-btn
                    color="success"
                    fab flat
                    slot="activator"
                    @click="openModalWithJSON(props.item)"
                  >
                    <v-icon>date_range</v-icon>
                  </v-btn>
                  <span>Approve</span>
                </v-tooltip>
              </td>
              <td>{{formActionDescription(props.item)}}</td>
            </template>
            <template slot="pageText" slot-scope="{}">
              Page {{pagination.page}} of {{getActionsTotalPages}}
            </template>
            <v-alert outline color="grey lighten-2" slot="no-results" :value="true" icon="warning">
              No data
            </v-alert>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-flex>

    <v-dialog v-model="isModalVisible" max-width="700px">
      <v-card>
        <v-card-title>
          Description JSON
        </v-card-title>
        <v-card-text>
          {{ actionDescriptionInJSON }}
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" flat @click.stop="closeModalWithJSON()">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { clone, path } from 'ramda'
import moment from 'moment' // lib to format date and time

export default {
  name: "UsersActions",
  props: {
    userScopes: {
      type: Array
    }
  },
  data () {
    return {
      search: {
        filterByName: '',
        filterByEmail: '',
        filterType: '',
      },
      page: 0,
      itemsOnPage: 25,
      loading: true,
      pagination: {
        rowsPerPage: 25,
        page: 0
      },
      usersActions: [],
      headers: [
        { text: 'Username', value: 'userName', sortable: false, width: '70' },
        { text: 'userEmail', value: 'userEmail', sortable: false,  width: '50' },
        { text: 'Date', value: 'actionDate', sortable: false,  width: '150' },
        { text: 'Action', value: 'action', sortable: false,  width: '150' },
        { text: 'Display JSON', value: 'action', sortable: false,  width: '30' },
        { text: 'Description', value: 'descripation', sortable: false }
      ],
      isModalVisible: false,
      actionDescriptionInJSON: {}
    }
  },
  computed: {
    ...mapGetters([
      'getUsersActions',
      'getActionsTotalPages',
      'getUserActionTypes',
      'getActionsTotalItems'
    ]),
    totalItemsToNumbers () {
      return parseInt(this.getActionsTotalItems) || 0
    },
    totalItemsInTable () {
      return this.getActionsTotalItems || (this.getActionsTotalPages * this.pagination.rowsPerPage)
    }
  },
  watch: {
    search: {
      handler (newVal) {
        let config = this.getFilterConfig(newVal)
        this.fetchAdminsActions(config)
      },
      deep: true
    },
    pagination: {
      handler (newVal, oldVal) {
        if (!this.isPaginationChanged(newVal, oldVal)) return
        const { page, rowsPerPage } = this.pagination
        this.page = page - 1 || 0
        this.itemsOnPage = rowsPerPage || 25
        if (rowsPerPage === -1) this.itemsOnPage = this.getActionsTotalItems
        let config = this.getFilterConfig()
        this.fetchAdminsActions(config)
      },
      deep: true
    },
  },
  methods: {
    ...mapActions([
      'fetchAdminsActions',
      'fetchActionsTypes'
    ]),
    getFilterConfig(search = this.search) {
      return {
          page: this.page,
          itemsOnPage: this.itemsOnPage,
          userName: path(['filterByName'], search),
          email: path(['filterByEmail'], search),
          type: path(['filterType'], search)
        }
    },
    openModalWithJSON (actionData) {
      this.actionDescriptionInJSON = actionData.description
      this.isModalVisible = true
    },
    closeModalWithJSON () {
      this.actionDescriptionInJSON = {}
      this.isModalVisible = false
    },
    formActionDescription ({ action, description, user: { userName } }) {
      try {
        let {body, error} = JSON.parse(description)
        if (error) {
          let errorDescription = error.code
            ? `Code: ${error.code} Message: ${error.message}`
            : `Message: ${error.message}`
          return `Administrator ${userName} got error: ${errorDescription}`
        } else {
          switch (action) {
            case 'ApproveAttendeeRegistrationCommand':
              return `Administrator ${userName} approved attendees with id: ${body.id}`
              break;
            case 'AttendeesForceDeleteCommand':
              return `Administrator ${userName} deleted attendees with ids: ${body.ids}`
              break;
            case 'UpdateAttendeeEmailNotificationSettingsCommand':
              return `Administrator ${userName} updated Attendee notification with key: ${body.notificationKey}`
              break;
            case 'UpdateAdminEmailNotificationSettingsCommand':
              return `Administrator ${userName} updated Admin notification with key: ${body.notificationKey}`
              break;
            case 'DisableVipInvitationCommand':
              return `Administrator ${userName} disabled VIP invitation with id: ${body.id}`
              break;
            case 'EnableVipInvitationCommand':
              return `Administrator ${userName} enabled VIP invitation. New tickets count: ${body.newTicketsCount}`
              break;
          }
        }
      } catch (err) {
        return `Failed to parse JSON`
      }
    },
    isPaginationChanged (newVal, oldVal) {
      if (!newVal && !oldVal) return
      return newVal.page !== oldVal.page || newVal.rowsPerPage !== oldVal.rowsPerPage
    },
    async receiveRequiredData () {
      await Promise.all([this.fetchAdminsActions(), this.fetchActionsTypes()])
    },
    getDate (date) {
      return date
        ? moment(date).format('DD-MM-YYYY, h:mm:ss a')
        : 'Unknown date'
    }
  },
  created () {
    this.receiveRequiredData()
  }
}
</script>




// WEBPACK FOOTER //
// src/components/pages/UsersActions/index.vue